<!-- Localized -->
<template>
    <div class="flex flex-1 flex-col overflow-y-auto w-full">
        <div class="flex space-x-6 overflow-y-auto py-3 rounded-lg h-full text-base-content-800">
            <div v-if="loadingState && loadingState.template"
                class="flex justify-center items-center min-h-full w-1/2"
            >
                <Loader />
            </div>
            <ListView 
                v-else
                :showSelectAll="false"
                :disableCheckbox="loadingState.assigningTemplate"
                :title="$t('pages.tenant_packages.template')"
                :listItems="allTemplates"
                :showSearch="true"
                class="h-full overflow-y-auto"
                @rowClick="handleTemplateClick($event)"
                @handleSelect="handleSelectAllTemplate($event)"
                @handleFilterResult="handleFilterTemplateResult($event)"
                @change="toggleTemplateSelection(template.id)"
            />
            <div v-if="loadingState && loadingState.sequence"
                class="flex justify-center items-center min-h-full w-1/2"
            >
                <Loader />
            </div>
            <ListView
                v-else
                :showSelectAll="false"
                :disableCheckbox="loadingState.assigningSequence"
                :title="$t('pages.tenant_packages.sequence')"
                :listItems="allSequences"
                :showSearch="true"
                class="h-full overflow-y-auto"
                @rowClick="handleSequenceClick($event)"
                @handleSelect="handleSelectAllSequence($event)"
                @handleFilterResult="handleFilterSequenceResult($event)"
                @change="toggleSequenceSelection(template.id)"
            />   
        </div>
    </div>
</template>
<script>

import axios from "@/axios"
import ListView from "@shared/components/lists";
import Loader from "@shared/loader";

export default {
    name: "email-template-sequence",
        components: {
            ListView,
            Loader,
        },
        data() {
            return{
                allTemplates: [],
                allSequences:[],
                loadingState: {
                    template: false,
                    sequence: false,
                    assigningTemplate: false,
                    assigningSequence: false,
                },
                originalTemplates: [],
                originalSequences: [],
                checkedTemplateIds: new Set(),
                sortParams: {},
                checkedSequenceIds: new Set()
            }
        },
        computed: {
            
        },
        watch: {
            
        },
        async mounted() {
            this.fetchTemplateList();
            this.fetchSequenceList();
        },
        methods:{ 
            async fetchTemplateList() {
                this.loadingState.template = true;
                try {
                    const url = `/email-template/list?external_id=${this.$store.getters.getTenantId}`;
                    const result = await axios.get(url, { params: { ...this.sortParams } });
                    // Recursive function to collect all "resource" type items
                    const collectResources = (items) => {
                        let resources = [];
                        for (const item of items) {
                            if (item.type === "resource") {
                                resources.push(item);
                            } else if (item.type === "directory" && Array.isArray(item.content)) {
                                resources.push(...collectResources(item.content));
                            }
                        }
                        return resources;
                    };
                    const content = result?.data?.content || [];
                    this.originalTemplates = collectResources(content);
                    this.allTemplates = this.applyCheckedState([...this.originalTemplates]);

                    if (this.allTemplates.length > 0) {
                        await this.fetchAssosiatedTemplateList();
                    }
                } catch (error) {
                    this.$toast.error(
                        error?.response?.data?.detail || this.$t('general.default_error2')
                    );
                } finally {
                    this.loadingState.template = false;
                }
            },
            async fetchSequenceList() {
                this.loadingState.sequence = true;
                try {
                    const url = `/email-sequence/list?external_id=${this.$store.getters.getTenantId}`;
                    const result = await axios.get(url, { params: { ...this.sortParams } });
                    const collectResources = (items) => {
                        let resources = [];
                        for (const item of items) {
                            if (item.type === "resource") {
                                resources.push(item);
                            } else if (item.type === "directory" && Array.isArray(item.content)) {
                                resources.push(...collectResources(item.content));
                            }
                        }
                        return resources;
                    };
                    const content = result?.data?.content || [];
                    this.originalSequences = collectResources(content);
                    this.allSequences = this.applySequenceCheckedState([...this.originalSequences]);

                    if (this.allSequences.length > 0) {
                    await this.fetchAssosiatedSequenceList();
                    }
                } catch (error) {
                    this.$toast.error(
                    error?.response?.data?.detail || this.$t('general.default_error2')
                    );
                } finally {
                    this.loadingState.sequence = false;
                }
            },
            async fetchAssosiatedTemplateList() {
                const url = '/email-template/associated/list/template/package';
                const params = {
                    external_id: this.$store.getters.getTenantId,
                    package_id: this.$route.params.packageName
                };

                try {
                    const { data: associatedTemplates } = await axios.get(url, { params });
                    const flatAssociatedResources = this.flattenAssociatedTemplates(associatedTemplates?.content || []);
                    this.checkedTemplateIds = new Set(
                        flatAssociatedResources
                            .filter(t => t.type === 'resource' && t.is_associated)
                            .map(t => t.id)
                    );
                    this.allTemplates = this.applyCheckedState([...this.allTemplates]);
                    this.originalTemplates = this.applyCheckedState([...this.originalTemplates]);
                } catch (error) {
                    console.error("Error fetching associated templates:", error);
                    this.$toast.warning(
                        error?.response?.data?.detail || "Failed to fetch associated templates"
                    );
                }
            },
            flattenAssociatedTemplates(templates) {
                const result = [];
                const traverse = (items) => {
                    for (const item of items) {
                        result.push(item);
                        if (item.type === 'directory' && Array.isArray(item.content)) {
                            traverse(item.content);
                        }
                    }
                };
                traverse(templates);
                return result;
            },
            async fetchAssosiatedSequenceList() {
                const url = '/email-sequence/associated/list/package';
                const params = {
                    external_id: this.$store.getters.getTenantId,
                    package_id: this.$route.params.packageName
                };

                try {
                    const { data: associatedTemplates } = await axios.get(url, { params });

                    const flatAssociatedResources = this.flattenAssociatedTemplates(associatedTemplates?.content || []);
                    this.checkedSequenceIds = new Set(
                        flatAssociatedResources
                            .filter(t => t.type === 'resource' && t.is_associated)
                            .map(t => t.id)
                    );
                    this.allSequences = this.applySequenceCheckedState([...this.allSequences]);
                    this.originalSequences = this.applySequenceCheckedState([...this.originalSequences]);

                } catch (error) {
                    console.error("Error fetching associated sequences:", error);
                    this.$toast.warning(
                    error?.response?.data?.detail || "Failed to fetch associated sequences"
                    );
                }
            },
            async handleTemplateClick({ row, value }) {
                const url = `/email-template/package-sequence-template`;
                this.loadingState.assigningTemplate = true;
                const payload = {
                    package_id: this.$route.params.packageName,
                    template_or_sequence_id: row?.id,
                    is_added: value,
                    req_type: "template"
                };
                try {
                    const { data } = await axios.post(url, payload);
                    this.$toast.success(data?.message || "Template assigned successfully.");

                    if (value) {
                        this.checkedTemplateIds.add(row.id);
                    } else {
                        this.checkedTemplateIds.delete(row.id);
                    }

                    this.allTemplates = this.applyCheckedState([...this.allTemplates]);
                    this.originalTemplates = this.applyCheckedState([...this.originalTemplates]);

                } catch (error) {
                    console.error("API Error:", error);
                    const detail = error.response?.data?.detail;
                    let message = detail || "Error while attaching template with package!";

                    // Regex to find content after '-' and before 'that does not exist'
                    const match = message.match(/-\s*(.+?)\s+that does not exist/i);

                    if (match && match[1]) {
                    const formsText = match[1].trim();
                    message = message.replace(formsText, `${formsText.toUpperCase()}`);
                    }
                    this.$toast.warning(message);
                    this.fetchTemplateList();
                } finally {
                    this.loadingState.assigningTemplate = false;
                }
            },
            async handleSequenceClick({ row, value }) {
                const url = `/email-template/package-sequence-template`;
                this.loadingState.assigningSequence = true;
                const payload = {
                    package_id: this.$route.params.packageName,
                    template_or_sequence_id: row?.id,
                    is_added: value,
                    req_type: "sequence"
                };
                try {
                    const { data } = await axios.post(url, payload);
                    this.$toast.success(data?.message || "Sequence assigned successfully.");

                    if (value) {
                        this.checkedSequenceIds.add(row.id);
                    } else {
                        this.checkedSequenceIds.delete(row.id);
                    }

                    this.allSequences = this.applySequenceCheckedState([...this.allSequences]);
                    this.originalSequences = this.applySequenceCheckedState([...this.originalSequences]);
                } catch (error) {
                    console.error("API Error:", error);
                    const detail = error.response?.data?.detail;
                    let message = detail || "Error while attaching sequence with package!";

                    // Regex to find content after '-' and before 'that does not exist'
                    const match = message.match(/-\s*(.+?)\s+that does not exist/i);

                    if (match && match[1]) {
                    const formsText = match[1].trim();
                    message = message.replace(formsText, `${formsText.toUpperCase()}`);
                    }
                    this.$toast.warning(message);
                    this.fetchSequenceList();
                } finally {
                    this.loadingState.assigningSequence = false;
                }
            },
            handleSelectAllTemplate(event) {
                if(event){
                    this.allTemplates = this.allTemplates.map((el) => ({ ...el, checked: event }));
                }
                else{
                    this.allTemplates = this.allTemplates.map((el) => ({ ...el, checked: event }));
                }
            },
            handleSelectAllSequence(event) {
                if(event){
                    this.allSequences = this.allSequences.map((el) => ({ ...el, checked: event }));
                }
                else{
                    this.allSequences = this.allSequences.map((el) => ({ ...el, checked: event }));
                }
            },
            applyCheckedState(templateList) {
                return templateList.map(template => ({
                    ...template,
                    checked: this.checkedTemplateIds.has(template.id)
                }));
            },

            handleFilterTemplateResult(searchText) {
                if (!searchText) {
                    this.allTemplates = this.applyCheckedState([...this.originalTemplates]);
                } else {
                    const lowerText = searchText.toLowerCase();
                    const filtered = this.originalTemplates.filter(template =>
                        template?.name?.toLowerCase().includes(lowerText)
                    );
                    this.allTemplates = this.applyCheckedState(filtered);
                }
            },
            toggleTemplateSelection(templateId) {
                if (this.checkedTemplateIds.has(templateId)) {
                    this.checkedTemplateIds.delete(templateId);
                } else {
                    this.checkedTemplateIds.add(templateId);
                }
                this.allTemplates = this.applyCheckedState([...this.allTemplates]);
                this.originalTemplates = this.applyCheckedState([...this.originalTemplates]);
            },
            applySequenceCheckedState(list) {
                return list.map(sequence => ({
                    ...sequence,
                    checked: this.checkedSequenceIds.has(sequence.id)
                }));
            },
            handleFilterSequenceResult(searchText) {
                const lowerText = searchText?.toLowerCase() || '';
                const filteredSequences = !lowerText
                    ? [...this.originalSequences]
                    : this.originalSequences.filter(sequence =>
                        sequence?.name?.toLowerCase().includes(lowerText)
                    );
                this.allSequences = filteredSequences.map(sequence => ({
                    ...sequence,
                    checked: this.checkedSequenceIds.has(sequence.id)
                }));
            },
            toggleSequenceSelection(sequenceId) {
                if (this.checkedSequenceIds.has(sequenceId)) {
                    this.checkedSequenceIds.delete(sequenceId);
                } else {
                    this.checkedSequenceIds.add(sequenceId);
                }
                this.allSequences = this.applySequenceCheckedState([...this.allSequences]);
                this.originalSequences = this.applySequenceCheckedState([...this.originalSequences]);
            },

        },
    };
</script>
<style scoped lang="scss">

</style>